import { render, staticRenderFns } from "./notice_receive.vue?vue&type=template&id=719bfb7b&scoped=true&"
import script from "./notice_receive.vue?vue&type=script&lang=js&"
export * from "./notice_receive.vue?vue&type=script&lang=js&"
import style0 from "./notice_receive.vue?vue&type=style&index=0&id=719bfb7b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719bfb7b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('719bfb7b')) {
      api.createRecord('719bfb7b', component.options)
    } else {
      api.reload('719bfb7b', component.options)
    }
    module.hot.accept("./notice_receive.vue?vue&type=template&id=719bfb7b&scoped=true&", function () {
      api.rerender('719bfb7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/task_manage/notice_manage/form/components/notice_receive.vue"
export default component.exports